import { AppInteractionLevel } from './app-metadata';

export type NoticeType = 'error' | 'warning' | 'info';

export enum NoticeKind {
  /**
   * TruncatedSeries that indicate a series has run into query truncation.
   */
  TruncatedSeries,
  /**
   * DuplicatedFormatted series name indicates that the series alias has led to duplicate series names
   */
  DuplicateFormattedSeriesName,
  /**
   * GlobalFilters indicates that an anomaly was encountered during injection of global filters.
   * Includes failed injection, conflicting matchers, etc.
   */
  GlobalFilters,

  /**
   * CompareModeNotSupported indicates that the compare mode is not supported by the requesting panel.
   */
  CompareModeNotSupported,
}

export interface Notice {
  /**
   * Controls which icon shows along with notice.
   */
  type: NoticeType;
  /**
   * Specific kind of notice
   * TODO: allow for scoping notice display (sc-108086)
   */
  kind?: NoticeKind;
  /**
   * Message to show along with the notice icon (inside tooltip by default).
   */
  message: string;
  /**
   * Additional, longer explanation of the notice.
   */
  description?: string;
  /**
   * Optional button that can be used for actions that are specific to each kind of notice.
   */
  action?: {
    label: string;
    onClick: () => void;
    isDanger?: boolean;
  };

  /**
   * Optional array of app interaction levels where this notice should be shown. Useful for limiting
   * notices that only make sense in specific use cases (e.g. when a user has the ability to edit
   * a query).
   *
   * When not set, the notice will always be shown.
   */
  appInteractionLevels?: AppInteractionLevel[];
}
